import { useAuth0 } from '@auth0/auth0-react';
import { useAtom } from 'jotai';
import { atomFamily, atomWithStorage } from 'jotai/utils';
import { asyncOperationsLocalStorage } from './local-storage';
import { type AsyncOperationsState, initialAsyncOperationsState } from './schema';

const STORAGE_KEY_BASE = 'async_operations';

export function getAsyncOperationsStorageKey(orgId: string | undefined) {
  return `${orgId}.${STORAGE_KEY_BASE}`;
}

const asyncOperationsAtomFamily = atomFamily((storageKey: string) =>
  atomWithStorage<AsyncOperationsState>(storageKey, initialAsyncOperationsState, asyncOperationsLocalStorage, {
    getOnInit: true,
  }),
);

export function useAsyncOperationsAtom() {
  const { user } = useAuth0();
  const storageKey = getAsyncOperationsStorageKey(user?.org_id);
  return useAtom(asyncOperationsAtomFamily(storageKey));
}
